/* global translation */
import { triggerEvent } from './functions';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}

jQuery(($) => {
  $(document).on('click', '.quiz-term-selector', (e) => {
    e.preventDefault();
    let data = getCookie('skin');
    if (!data) {
      data = [];
    } else {
      data = JSON.parse(data);
    }
    const date = new Date();
    date.setTime(date.getTime() + (360 * 24 * 60 * 60 * 1000));
    const expires = `; expires=${date.toGMTString()}`;
    const clickedEl = e.currentTarget;
    const chosenValue = parseFloat(e.currentTarget.dataset.termId);
    const inArr = data.indexOf(chosenValue);
    const tipModules = document.getElementsByClassName('tip-module-list');

    if (inArr !== -1) {
      data.splice(inArr, 1);
      clickedEl.classList.remove('active');
    } else {
      data.push(chosenValue);
      clickedEl.classList.add('active');
    }
    document.cookie = `skin=${JSON.stringify(data)}; expires=${expires}; path=/`;

    for (let i = 0; i < tipModules.length; i += 1) {
      tipModules[i].classList.remove('loaded');
      tipModules[i].classList.add('loading');
    }

    if (tipModules.length) {
      jQuery.post(translation.ajaxurl, { action: 'tips_list' }, (response) => {
        for (let i = 0; i < tipModules.length; i += 1) {
          tipModules[i].innerHTML = response;
          tipModules[i].classList.add('loaded');
          tipModules[i].classList.remove('loading');
        }
      });
    }
  });

  let activeResponse = '';
  $(document).on('click', '.edit-skin .small-quiz-module .quiz-term-selector', (e) => {
    const activeQuizItems = document.getElementsByClassName('chosen-skin-types');
    const productList = document.querySelector('main.site-main ul.products');
    const parentUL = e.currentTarget.parentNode.parentNode;
    productList.classList.add('loading');
    parentUL.classList.add('loading');

    for (let i = 0; i < activeQuizItems.length; i += 1) {
      activeQuizItems[i].classList.add('loading');
    }

    // Timeout to make sure cookie is set before triggering the rest
    setTimeout(() => {
      jQuery.post(translation.ajaxurl, { action: 'active_items_list' }, (actResponse) => {
        activeResponse = actResponse;

        jQuery.get(window.location.href, (response) => {
          const htmlObject = document.createElement('html');
          htmlObject.innerHTML = response;

          const newProducts = Array.from(htmlObject.querySelectorAll('ul.products > li'));

          // Clear existing products
          productList.innerHTML = '';

          // Add new products
          newProducts.forEach((element) => {
            productList.appendChild(element);
          });

          // Remove current pagination
          const currentPagination = document.querySelector('main.site-main .woocommerce-pagination');
          const pagination = htmlObject.querySelector('main.site-main .woocommerce-pagination');

          if (currentPagination) {
            currentPagination.parentNode.removeChild(currentPagination);
          }

          if (pagination) {
            productList.parentNode.appendChild(pagination);
          }

          triggerEvent(productList, 'updated');

          for (let i = 0; i < activeQuizItems.length; i += 1) {
            const activeParent = activeQuizItems[i].parentNode;
            const infoText = activeParent.querySelector('.info-text');
            if (activeResponse) {
              infoText.innerHTML = translation.your_skin;
            } else {
              infoText.innerHTML = '';
            }
            activeQuizItems[i].innerHTML = activeResponse;
            activeQuizItems[i].classList.add('loaded');
            activeQuizItems[i].classList.remove('loading');
          }

          productList.classList.remove('loading');
          parentUL.classList.remove('loading');
        });
      });
    }, 100);
  });

  $(document).on('click', '.module-quiz-module.small-layout .edit-skin-link', (e) => {
    e.preventDefault();
    const button = e.currentTarget;
    const text = button.querySelector('.text');
    const quiz = button.parentNode.querySelector('.edit-skin');
    const activeSkins = button.parentNode.querySelector('.chosen-skin-types');
    if (button.classList.contains('close')) {
      button.classList.remove('close');
      if (activeResponse || activeSkins.innerHTML.length > 0) {
        text.innerHTML = translation.edit;
      } else {
        text.innerHTML = translation.choose_skin;
      }
      quiz.classList.remove('open');
      quiz.style.height = 0;
    } else {
      button.classList.add('close');
      text.innerHTML = translation.close;
      quiz.style.height = `${quiz.querySelector('.small-quiz-module').clientHeight}px`;
    }
  });
});
